<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="731.67004"
    height="435.02925"
    viewBox="0 0 731.67004 435.02925"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M79.4806,306.78792c-3.16093,.3401-6.60921,.85055-10.27718,1.59744-15.55246,3.16687-15.87526,13.72736-15.73896,16.14847l-.10566-.06586c-1.56382,2.50859-2.54325,5.0473-3.13519,7.44337l-.71221-32.36652c.46052-.9602,.87954-2.04896,1.22889-3.16494,1.16419,3.58504,3.07256,6.97195,4.7176,6.74748,2.13909-.2919,3.07167-6.58596,2.67265-11.05881,2.72016,3.50314,7.2981,7.24972,9.02511,6.09446,1.38001-.92313,.56173-4.72359-.94492-8.17871,3.13929,1.89132,6.61613,3.13439,7.69503,1.93342,1.47227-1.63885-2.05557-7.23082-5.30905-10.35235,4.35496,.40613,9.89372-.28771,10.25684-2.26977,.2992-1.6331-2.99722-3.69384-6.5255-5.02014,3.5439-.93441,6.85789-2.56256,6.74798-4.17324-.13057-1.91338-5.05068-3.19543-9.29526-3.39051,3.20154-2.50471,6.14321-5.96711,5.24362-7.53303-.82704-1.43962-4.67439-.88198-8.22406,.38596,2.10064-3.00326,3.5775-6.38742,2.45277-7.54556-1.40106-1.44266-6.37359,1.04738-9.76711,3.79978,.66062-4.28797,.32665-9.70052-1.59659-10.19022-1.60895-.40967-3.88929,2.73886-5.4527,6.16866-.69097-3.59931-2.08979-7.01645-3.7042-7.01645-2.29982,0-4.16418,6.93399-4.16418,11.45149,0,.25536,.00677,.49574,.01843,.72541-.23083-.26761-.49538-.54719-.79707-.84018-3.24076-3.14728-9.51391-6.64064-11.11616-4.99082-1.12474,1.15814,.35212,4.5423,2.45277,7.54556-3.54967-1.26794-7.39702-1.82559-8.22406-.38596-1.11127,1.93439,3.63883,6.76323,7.4999,9.10499-.2321-.02796-.47595-.0515-.73547-.0692-4.50701-.30752-11.55183,1.08049-11.7084,3.37497-.10991,1.61067,3.20409,3.23883,6.74798,4.17324-3.52829,1.3263-6.8247,3.38704-6.5255,5.02014,.36312,1.98206,5.90188,2.6759,10.25684,2.26977-3.25348,3.12154-6.78132,8.7135-5.30905,10.35235,1.0789,1.20097,4.55573-.0421,7.69503-1.93342-1.50665,3.45512-2.32492,7.25558-.94492,8.17871,1.82373,1.21996,6.82541-3.02601,9.4625-6.67949-.2687,4.46965,.80077,10.61004,2.9228,10.85236,.88742,.10134,1.82777-.84507,2.67643-2.3023l-2.40356,34.79012c-.56184,4.05159,3.03199,6.69542,3.35318,8.36434l.51842,23.5593c-.58508-1.67794-1.37316-3.3952-2.43548-5.09933l-.10566,.0659c.13628-2.42136-.18675-12.98155-15.73896-16.14836-3.66797-.74689-7.11625-1.25734-10.27718-1.59744-3.73116-.40145-5.1866,4.70611-1.81595,6.35581,4.88144,2.38917,9.4733,5.39935,11.86668,8.96403,6.11901,9.11359,14.5737,3.84542,15.77578,3.0275,1.34266,2.23509,2.22306,4.48687,2.77913,6.62945l.27531,12.51144c-.06744,.2959-.11414,.46159-.11777,.47403l.12902,.03782,.66628,30.27884,6.18057-.04965-2.21068-30.94947c.37149-1.66957,1.51435-7.35722,0-13.26406l-2.21068-24.31744h0c-.0055-.01877,.12548,.63842,0,0l-2.8837-9.55504c.41933-2.95604,1.3925-6.28098,3.36894-9.57097,1.20206,.81791,9.65677,6.08611,15.77579-3.0275,2.39338-3.56469,6.98524-6.57486,11.86668-8.96403,3.37065-1.64971,1.91521-6.75726-1.81595-6.35581Zm-28.23342,71.6385l-.11651-5.2952c.23499,2.00214,.2231,3.80933,.11651,5.2952Z"
      fill="#f2f2f2"
    />
    <path
      d="M0,414.28654c0,.66003,.53003,1.19,1.19006,1.19H730.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z"
      fill="#3f3d56"
    />
    <g>
      <circle
        cx="442.57912"
        cy="361.34189"
        r="54"
        fill="#3f3d56"
      />
      <circle
        cx="442.57912"
        cy="361.34189"
        r="36"
        fill="#fff"
      />
      <circle
        cx="442.57912"
        cy="361.34189"
        r="20.5"
        fill="#3f3d56"
      />
      <circle
        cx="130.57912"
        cy="361.34189"
        r="54"
        fill="#3f3d56"
      />
      <circle
        cx="130.57912"
        cy="361.34189"
        r="36"
        fill="#fff"
      />
      <path
        d="M516.4507,335.65952c-7.0343-17.72699-31.6145-71.89722-75.38574-89.8252-.33667-.13788-.69055-.2323-1.05078-.28394l-140.40552-20.11157c-2.31384-.33142-4.4668,1.2514-4.84045,3.55872l-2.46179,15.19843c-.16907,1.04352,.05078,2.11212,.62354,3.00067,7.13062,11.06281,52.8291,86.14526-20.35083,86.14526-72.0304,0-93.34912-52.37433-96.55017-61.61548-.30237-.87292-.31458-1.81287-.03638-2.69379l22.18445-70.25055c.39453-1.24982,.17627-2.52936-.46082-3.55219l9.75183-18.11243,17.86304,10.11218,9.24805,.11224,31.5708,16.5,6.4292-10.5-65.11108-32.47638s.11108-7.52362-20.88892-13.52362l-33-15-4,5,10,8,1,6,7,2,14,27-4,7.73621,4.85522,2.36725-1.39453-.31696c-2.00781-.4563-4.05664,.57898-4.88013,2.46619l-22.06299,50.56097c-.33752,.77362-.896,1.43042-1.60522,1.88806l-7.85925,5.07056c-.73438,.47382-1.3064,1.16071-1.63953,1.96863l-8.97632,21.77301c-.27979,.67841-.35962,1.38977-.28735,2.0777-11.18994,2.1203-44.08435,11.27728-62.1499,47.40839l21,17s32.91797-21.29877,87.32153,.88074c9.45569,14.71802,23.2511,26.9325,43.16772,28.0838,52.51074,3.03546,139.51074,6.03546,149.51074-5.96454,7.32092-8.78516,12.41357-14.27008,14.61694-16.57843,.77625-.81335,1.83582-1.28357,2.95959-1.31952l122.44885-3.91125c2.97253-.09491,4.94312-3.10883,3.84619-5.87317Z"
        :fill="color"
      />
      <circle
        cx="178.57912"
        cy="162.34189"
        r="16"
        fill="#3f3d56"
      />
      <path
        d="M434.81349,245.8956c-.18945,0-.37988-.00391-.57129-.01074l-133.77832-5.17871c-5.91992-.22949-10.99023-3.99805-12.91699-9.60059l-1.83105-5.32861c-1.49414-4.34473-.84473-8.99902,1.78125-12.76855,2.62598-3.77002,6.76562-5.99268,11.3584-6.09863l138.2168-3.17725c4.28027-.09814,8.40039,1.73438,11.19434,5.03271,2.79297,3.29736,3.93164,7.62402,3.12305,11.86963l-2.60645,13.68359c-1.29297,6.78809-7.11914,11.57715-13.96973,11.57715Z"
        fill="#3f3d56"
      />
      <circle
        cx="130.57912"
        cy="361.34189"
        r="20.5"
        fill="#3f3d56"
      />
      <path
        d="M488.55763,302.97861c-3.20215,0-6.25098-1.71484-7.87598-4.65527l-10.13477-18.33984c-1.60547-2.90527-1.51367-6.31934,.24512-9.13379,1.75879-2.81543,4.79688-4.4043,8.10254-4.22266l18.38574,.94238c3.42383,.17578,6.5,2.3291,7.83691,5.48828l5.37305,12.69727c.98242,2.3252,.95801,4.87402-.06836,7.17969-1.02734,2.30469-2.90723,4.02734-5.29297,4.85059l-13.62402,4.69727c-.97266,.33594-1.9668,.49609-2.94727,.49609Z"
        fill="#3f3d56"
      />
      <path
        d="M256.0088,424.86826c-.15234,0-.30566-.00879-.45996-.02539l-4.08301-.4541c-1.33398-.14844-2.48828-.89746-3.16797-2.05566-.67969-1.15723-.77051-2.53125-.25-3.76855l21.2373-50.43848,.46094,.19434-.46094-.19434c.58301-1.38477,1.87109-2.36035,3.36133-2.54688,1.4502-.18457,2.86426,.38574,3.78711,1.5166,.92285,1.12988,1.19531,2.62988,.72949,4.0127l-17.1543,50.89258c-.57812,1.71777-2.21582,2.86719-4,2.86719Z"
        fill="#3f3d56"
      />
    </g>
    <path
      d="M366.27542,72.88192s-7.76959-15.53917-6.21567-29.52443l-25.85872,13.40338,.99604,25.44455,31.07835-9.3235Z"
      fill="#a0616a"
    />
    <circle
      cx="350.22805"
      cy="40.61132"
      r="23.32656"
      fill="#a0616a"
    />
    <g>
      <polygon
        points="374.05593 406.92753 359.8217 406.92615 353.05039 352.02205 374.05879 352.02353 374.05593 406.92753"
        fill="#a0616a"
      />
      <path
        d="M325.28766,406.60464h0c-.4432,.74644-.67706,3.15561-.67706,4.02365h0c0,2.66814,2.16292,4.83116,4.83116,4.83116h44.08176c1.82019,0,3.29584-1.47556,3.29584-3.29584v-1.83526s2.18068-5.51593-2.30896-12.31461c0,0-5.58002,5.32347-13.918-3.01451l-2.4588-4.4543-17.79831,13.01679-9.86533,1.21433c-2.15833,.26565-4.0719-.04123-5.18212,1.82859h-.00017Z"
        fill="#2f2e41"
      />
    </g>
    <path
      d="M332.08923,72.88192l34.18618-4.66175,26.4166,12.43134,1.55392,96.34288s-64.98312,7.76959-75.22429-2.33088c-10.24117-10.10046-2.47159-90.90417-2.47159-90.90417l15.53917-10.87742Z"
      fill="#e6e6e6"
    />
    <path
      d="M344.39354,46.55382h-6.2709s-5.44093-6.69742-4.70894-2.61672c.73199,4.0807-2.19597,8.47264-2.19597,8.47264l-4.39194-1.46398s-8.78388-36.93378,17.56775-38.9626c26.35163-2.02882,32.20755,18.46689,32.20755,18.46689,0,0-1.46398,10.24786-4.39194,7.3199s-19.03173-4.39194-19.03173-4.39194l-8.78388,13.17582Z"
      fill="#2f2e41"
    />
    <g>
      <polygon
        points="316.26263 298.22368 303.24435 303.98023 274.84276 256.5075 294.05629 248.01084 316.26263 298.22368"
        fill="#a0616a"
      />
      <path
        d="M271.53169,317.6554h0c-.10339,.86192,.65726,3.15979,1.00839,3.95365h0c1.07928,2.44011,3.9323,3.54335,6.37249,2.46404l40.31435-17.8313c1.66463-.73628,2.41729-2.68263,1.68098-4.34734l-.74237-1.67841s-.23691-5.92661-7.09294-10.32816c0,0-2.94976,7.12565-13.9479,2.87302l-4.05045-3.07902-11.01183,19.10382-8.531,5.10113c-1.86642,1.116-3.74057,1.6094-3.99955,3.76851l-.00016,.00007Z"
        fill="#2f2e41"
      />
    </g>
    <path
      d="M389.58418,167.67088l4.66175,14.09538v48.45286s-15.22717,43.89511-15.22717,43.89511l1.24191,102.34443h-27.32203s-3.08336-104.39389-3.08336-104.39389l2.43488-51.5607-18.64701-7.76959-48.97899,3.02294,22.90499,56.30734-25.20528,16.81167s-37.69779-85.91206-32.0572-94.23531c5.6406-8.32325,71.68199-23.00593,71.68199-23.00593,0,0,67.59551-2.41041,67.59551-3.96432Z"
      fill="#2f2e41"
    />
    <g>
      <path
        d="M403.56944,111.72985l7.51264,12.30434s10.62048,41.74319,0,41.91298c-10.62048,.16979-32.06331-21.27305-32.06331-21.27305l2.79583-11.18943,7.76959,3.10783-1.55392-24.86268h15.53917Z"
        fill="#a0616a"
      />
      <path
        d="M380.26067,80.45573s24.86268-4.38033,27.19356,11.89297c2.33088,16.27331,3.62785,31.68549,3.62785,31.68549l-26.93661,2.23151-3.88479-45.80998Z"
        fill="#e6e6e6"
      />
      <ellipse
        cx="374.22905"
        cy="135.16627"
        rx="7.01522"
        ry="14.03044"
        transform="translate(47.03317 361.57334) rotate(-54.54076)"
        fill="#a0616a"
      />
    </g>
    <path
      d="M590.4806,306.78792c-3.16093,.3401-6.60921,.85055-10.27718,1.59744-15.55246,3.16687-15.87526,13.72736-15.73896,16.14847l-.10566-.06586c-1.56382,2.50859-2.54325,5.0473-3.13519,7.44337l-.71221-32.36652c.46052-.9602,.87954-2.04896,1.22889-3.16494,1.16419,3.58504,3.07256,6.97195,4.7176,6.74748,2.13909-.2919,3.07167-6.58596,2.67265-11.05881,2.72016,3.50314,7.2981,7.24972,9.02511,6.09446,1.38001-.92313,.56173-4.72359-.94492-8.17871,3.13929,1.89132,6.61613,3.13439,7.69503,1.93342,1.47227-1.63885-2.05557-7.23082-5.30905-10.35235,4.35496,.40613,9.89372-.28771,10.25684-2.26977,.2992-1.6331-2.99722-3.69384-6.5255-5.02014,3.5439-.93441,6.85789-2.56256,6.74798-4.17324-.13057-1.91338-5.05068-3.19543-9.29526-3.39051,3.20154-2.50471,6.14321-5.96711,5.24362-7.53303-.82704-1.43962-4.67439-.88198-8.22406,.38596,2.10064-3.00326,3.5775-6.38742,2.45277-7.54556-1.40106-1.44266-6.37359,1.04738-9.76711,3.79978,.66062-4.28797,.32665-9.70052-1.59659-10.19022-1.60895-.40967-3.88929,2.73886-5.4527,6.16866-.69097-3.59931-2.08979-7.01645-3.7042-7.01645-2.29982,0-4.16418,6.93399-4.16418,11.45149,0,.25536,.00677,.49574,.01843,.72541-.23083-.26761-.49538-.54719-.79707-.84018-3.24076-3.14728-9.51391-6.64064-11.11616-4.99082-1.12474,1.15814,.35212,4.5423,2.45277,7.54556-3.54967-1.26794-7.39702-1.82559-8.22406-.38596-1.11127,1.93439,3.63883,6.76323,7.4999,9.10499-.2321-.02796-.47595-.0515-.73547-.0692-4.50701-.30752-11.55183,1.08049-11.7084,3.37497-.10991,1.61067,3.20409,3.23883,6.74798,4.17324-3.52829,1.3263-6.8247,3.38704-6.5255,5.02014,.36312,1.98206,5.90188,2.6759,10.25684,2.26977-3.25348,3.12154-6.78132,8.7135-5.30905,10.35235,1.0789,1.20097,4.55573-.0421,7.69503-1.93342-1.50665,3.45512-2.32492,7.25558-.94492,8.17871,1.82373,1.21996,6.82541-3.02601,9.4625-6.67949-.2687,4.46965,.80077,10.61004,2.9228,10.85236,.88742,.10134,1.82777-.84507,2.67643-2.3023l-2.40356,34.79012c-.56184,4.05159,3.03199,6.69542,3.35318,8.36434l.51842,23.5593c-.58508-1.67794-1.37316-3.3952-2.43548-5.09933l-.10566,.0659c.13628-2.42136-.18675-12.98155-15.73896-16.14836-3.66797-.74689-7.11625-1.25734-10.27718-1.59744-3.73116-.40145-5.1866,4.70611-1.81595,6.35581,4.88144,2.38917,9.4733,5.39935,11.86668,8.96403,6.11901,9.11359,14.5737,3.84542,15.77578,3.0275,1.34266,2.23509,2.22306,4.48687,2.77913,6.62945l.27531,12.51144c-.06744,.2959-.11414,.46159-.11777,.47403l.12902,.03782,.66628,30.27884,6.18057-.04965-2.21068-30.94947c.37149-1.66957,1.51435-7.35722,0-13.26406l-2.21068-24.31744h0c-.0055-.01877,.12548,.63842,0,0l-2.8837-9.55504c.41933-2.95604,1.3925-6.28098,3.36894-9.57097,1.20206,.81791,9.65677,6.08611,15.77579-3.0275,2.39338-3.56469,6.98524-6.57486,11.86668-8.96403,3.37065-1.64971,1.91521-6.75726-1.81595-6.35581Zm-28.23342,71.6385l-.11651-5.2952c.23499,2.00214,.2231,3.80933,.11651,5.2952Z"
      fill="#f2f2f2"
    />
    <g>
      <polygon
        points="518.5126 409.07339 529.25616 406.75105 525.41339 364.20599 509.5568 367.63312 518.5126 409.07339"
        fill="#a0616a"
      />
      <path
        d="M555.26952,400.87663h0c.45625,.49112,1.02565,2.27139,1.16721,2.92658h0c.43512,2.01388-.84469,3.99921-2.85863,4.43434l-33.27226,7.18877c-1.37386,.29683-2.72828-.57625-3.02513-1.95017l-.29929-1.38523s-2.54547-3.80772-.26548-9.67142c0,0,5.07986,3.1081,10.0135-4.54503l1.12947-3.76301,15.55666,6.92236,7.64424-.69226c1.6724-.15147,3.06668-.69516,4.20959,.53511l.00013-.00003Z"
        fill="#2f2e41"
      />
    </g>
    <g>
      <polygon
        points="537.72969 405.81854 546.69283 399.45618 526.4195 361.85511 513.19049 371.245 537.72969 405.81854"
        fill="#a0616a"
      />
      <path
        d="M568.29634,383.81995h0c.61269,.27198,1.83665,1.6846,2.2246,2.23124h0c1.19243,1.68022,.79705,4.00898-.88322,5.20145l-27.7597,19.70078c-1.14623,.81347-2.73494,.54375-3.54845-.60254l-.82021-1.15572s-3.83839-2.49898-4.04955-8.78681c0,0,5.89305,.85857,7.41738-8.1185l-.44231-3.90389,17.02556,.24276,6.75522-3.64426c1.47789-.79731,2.54578-1.84575,4.08057-1.16444l.00011-.00008Z"
        fill="#2f2e41"
      />
    </g>
    <path
      d="M408.60499,195.47348s-16.71444,22.72462,16.71444,48.27336l68.25063-21.80883-24.37522-50.83975-21.58948-11.83939-39.00036,36.21462Z"
      fill="#2f2e41"
    />
    <polyline
      points="493.57005 221.938 520.03458 273.47419 536.74902 380.72518 515.85597 382.11805 494.96292 280.43854 458.05187 225.42018 483.81997 213.58078"
      fill="#2f2e41"
    />
    <path
      d="M425.31943,227.55884v16.188s47.35758,52.01327,47.35758,52.01327c0,0,0,39.00036,18.10731,57.10767l20.89305,32.03601,18.10731-9.75009-26.46453-93.32229-47.35758-61.28628-30.64314,7.0137Z"
      fill="#2f2e41"
    />
    <path
      d="M458.97238,67.07056l-8.9213,34.01246-34.01246-6.69098s23.73245-24.4692,20.38696-35.62082l22.54681,8.29934Z"
      fill="#a0616a"
    />
    <path
      d="M432.98021,72.20449l20.89305,9.75009s10.74813,6.56952,10.94554,10.94554-1.19546,25.26907-1.19546,25.26907c0,0,8.35722,8.35722,2.78574,25.07166l2.78574,27.8574-62.67915,33.42888,5.57148-58.50054-2.78574-54.32193,23.67879-19.50018Z"
      fill="#3f3d56"
    />
    <g>
      <path
        id="uuid-890a8f78-7002-4fae-ad75-e03b10042fc6-64"
        d="M414.22601,230.7154c2.44625,5.61267,7.32512,8.9,10.89681,7.3426,3.57168-1.5574,4.48319-7.36904,2.03532-12.98338-.94706-2.25611-2.42065-4.25262-4.29748-5.82247l-10.66518-23.65021-10.99167,5.24142,11.68095,22.75845c-.12744,2.44429,.33248,4.88356,1.34127,7.11359Z"
        fill="#a0616a"
      />
      <path
        d="M425.31943,95.18684s-15.32157-9.75009-20.89305,1.39287c-5.57148,11.14296-18.10731,68.25063-18.10731,68.25063l18.10731,54.32193,16.71444-6.96435-14.62513-58.46215,18.80374-58.53892Z"
        fill="#3f3d56"
      />
    </g>
    <g>
      <path
        id="uuid-bf6bc2d3-f134-421c-a442-5bb07c25212c-65"
        d="M503.84573,221.94721c4.34193,4.3167,10.08872,5.57542,12.83544,2.81173,2.74672-2.76368,1.45308-8.50237-2.89097-12.82002-1.71161-1.74853-3.81708-3.06173-6.14024-3.82974l-18.6279-18.05769-8.28762,8.92215,19.24369,16.85443c.78201,2.31933,2.10822,4.41759,3.86761,6.11913Z"
        fill="#a0616a"
      />
      <path
        d="M464.22958,91.8641s-26.71193-1.09243-27.78643,11.31936c-1.0745,12.41178,17.18611,67.79371,17.18611,67.79371l36.84618,43.83042,12.97314-12.63219-35.1342-48.96229-4.0848-61.34901Z"
        fill="#3f3d56"
      />
    </g>
    <g>
      <path
        d="M437.94325,172.61873l-22.31262-67.72848c-18.03755-15.89486-37.60581,22.37534-90.1362,.68176l16.5223,76.61104c39.71683-21.4702,73.90306-29.87926,95.92652-9.56432Z"
        fill="#fff"
      />
      <path
        d="M342.01662,183.1832c-.14258,0-.28516-.03027-.41797-.0918-.28613-.13135-.49316-.38965-.55957-.69727l-16.52246-76.61133c-.07812-.36328,.05078-.74023,.33691-.97852,.28516-.23828,.67871-.29834,1.02246-.15674,29.8418,12.32422,49.10352,4.98682,63.16504-.37109,10.69141-4.07373,19.13379-7.28809,27.25098-.13672,.13379,.11768,.2334,.26855,.28906,.4375l22.3125,67.72852c.14258,.43262-.02539,.90723-.40918,1.15381-.38281,.24561-.88574,.20264-1.21875-.10596-19.36328-17.86084-49.47852-14.77734-94.77344,9.70947-.14844,.08008-.31152,.12012-.47559,.12012Zm-15.14746-75.979l15.84473,73.46826c43.46094-23.2749,73.22754-26.86182,93.16211-11.13428l-21.1084-64.07373c-7.15137-6.12402-14.6582-3.26367-25.01367,.68115-14.10059,5.37158-33.30762,12.68994-62.88477,1.05859Z"
        fill="#3f3d56"
      />
    </g>
    <g>
      <path
        d="M298.5888,112.72985l-7.51264,12.30434s-10.62048,41.74319,0,41.91298c10.62048,.16979,32.06331-21.27305,32.06331-21.27305l-2.79583-11.18943-7.76959,3.10783,1.55392-24.86268h-15.53917Z"
        fill="#a0616a"
      />
      <path
        d="M321.89756,81.45573s-24.86268-4.38033-27.19356,11.89297c-2.33088,16.27331-3.62785,31.68549-3.62785,31.68549l26.93661,2.23151,3.88479-45.80998Z"
        fill="#e6e6e6"
      />
      <ellipse
        cx="327.92919"
        cy="136.16627"
        rx="14.03044"
        ry="7.01522"
        transform="translate(-18.17174 215.49442) rotate(-35.45924)"
        fill="#a0616a"
      />
    </g>
    <circle
      cx="585.62739"
      cy="413.49611"
      r="8.43804"
      fill="#3f3d56"
    />
    <circle
      cx="596.87811"
      cy="426.59121"
      r="8.43804"
      fill="#3f3d56"
    />
    <circle
      cx="681.25852"
      cy="426.59121"
      r="8.43804"
      fill="#3f3d56"
    />
    <path
      d="M609.23818,300.28511v-91.64795c0-10.26025,8.58068-12.79527,18.84094-12.79527,5.02832,0,7.47363-.58447,11,3,3.52588,3.58447,7.45496,5.0731,7.37244,10.10093l-1.47656,89.93018-35.73682,1.41211Zm19.84094-98.44321c-9.15771,0-17.84094-2.36245-17.84094,6.79527v89.56787l31.76807-1.25586,1.44531-88.03955c.07373-4.48682-7.22547-3.86851-10.37244-7.06773-3.14746-3.19922-.51221,0-5,0Z"
      fill="#3f3d56"
    />
    <path
      d="M584.12362,299.18225l-1.28372,100.13044c-.01652,1.28895,.29088,2.56141,.89401,3.70066l9.45952,17.86799c1.3914,2.62821,4.17212,4.21999,7.14303,4.08892l83.06468-3.66462c4.2518-.18758,7.54468-3.78952,7.3511-8.04105l-5.20589-114.33381c-.1872-4.11128-3.57487-7.34821-7.6904-7.34821h-86.03459c-4.2132,0-7.64373,3.38683-7.69774,7.59968Z"
      fill="#e6e6e6"
    />
    <path
      d="M616.8622,344.37007l-1.99707-.09961,.74121-14.82031c.39893-7.98242,6.97021-14.37988,14.96045-14.56641l35.37402-.82227c7.14453-.125,13.05762,5.29492,13.4541,12.43359l.75244,13.55078-1.99707,.11133-.75244-13.55078c-.33594-6.05469-5.38623-10.69141-11.41016-10.54492l-35.37402,.82227c-6.94824,.16113-12.66309,5.72559-13.01025,12.66602l-.74121,14.82031Z"
      fill="#3f3d56"
    />
    <path
      d="M615.45205,416.14546l-1.98926-.20312,4.31396-42.06348c.79785-7.77832,7.28906-13.90723,15.09912-14.25684l34.50098-1.54688c4.34619-.19629,8.47656,1.34277,11.63525,4.33203,3.15918,2.98926,4.92432,7.0293,4.97021,11.37793l.38574,36.62207-2,.02148-.38574-36.62207c-.04004-3.80176-1.58301-7.33398-4.34473-9.94629s-6.38574-3.95996-10.1709-3.78711l-34.50098,1.54688c-6.82764,.30566-12.50195,5.66309-13.19971,12.46191l-4.31396,42.06348Z"
      fill="#3f3d56"
    />
    <path
      d="M599.98769,413.24409l-2-.02539,1.26465-96.12012c.08643-6.57324,5.30078-11.87305,11.87109-12.06641l67.99609-2.00293,.05859,2-67.99609,2.00293c-5.49561,.16113-9.85742,4.59473-9.92969,10.0918l-1.26465,96.12012Z"
      fill="#3f3d56"
    />
    <path
      d="M600.16675,399.54666h-1.39v-87.54c0-2.77-2.25-5.03-5.03-5.03h-7.77v-2h7.77c3.67,0,6.69,2.83,7,6.41,.02,.2,.03,.41,.03,.62v41.45l-.61,46.09Z"
      fill="#3f3d56"
    />
    <g>
      <path
        d="M473.49036,48.8863c0,12.81596-10.38939,23.20534-23.20534,23.20534-12.81596,0-23.20534-10.38939-23.20534-23.20534,0-12.81596,10.38939-23.20534,23.20534-23.20534,12.81596,0,23.20534,10.38939,23.20534,23.20534Z"
        fill="#a0616a"
      />
      <path
        d="M448.43302,17.68833c.67147,.39196,1.57089-.20107,1.78619-.94816,.21531-.7471-.0355-1.54031-.28421-2.27696-.41735-1.23613-.8347-2.47226-1.25205-3.7084-.88798-2.63008-1.83043-5.35206-3.75358-7.35389-2.90268-3.02144-7.51572-3.79008-11.66838-3.23323-5.33283,.71511-10.5945,3.60278-13.07411,8.37792s-1.42395,11.43818,3.05655,14.41739c-6.38568,7.31906-8.61164,15.47589-8.26017,25.1827,.35147,9.7068,10.92951,18.64023,17.8278,25.47829,1.54051-.93384,2.94102-5.3102,2.09388-6.90004-.84714-1.58984,.36662-3.43172-.68254-4.89613-1.04916-1.46441-1.92691,.86737-.86624-.58873,.6693-.91882-1.94297-3.03263-.94809-3.58257,4.81205-2.65993,6.4125-8.65794,9.43477-13.25107,3.64542-5.54017,9.88457-9.29203,16.48723-9.91447,3.63718-.34288,7.47884,.27814,10.4601,2.38972,2.98126,2.11157,4.9113,5.88492,4.21998,9.47222,1.79041-1.81793,2.68165-4.4821,2.3455-7.01141-.33615-2.52932-1.89231-4.86823-4.0954-6.15541,1.33957-4.42989,.192-9.52557-2.91721-12.95357-3.10921-3.428-15.72188-2.84415-20.26109-1.94196l.35106-.60224Z"
        fill="#2f2e41"
      />
      <path
        d="M447.7281,34.62546c-6.01205,.649-10.35292,5.85678-14.01842,10.66615-2.11271,2.77201-4.32576,5.83324-4.27272,9.31817,.05362,3.52337,2.40936,6.54542,3.53519,9.8845,1.84022,5.45783,.04671,11.95139-4.33384,15.69106,4.32848,.82138,9.00767-2.42411,9.75491-6.766,.86987-5.05449-2.96167-9.93285-2.5079-15.04153,.39978-4.50081,3.94662-7.96472,6.96195-11.32996,3.01533-3.36525,5.84726-7.83084,4.46005-12.13117l.42077-.29122Z"
        fill="#2f2e41"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default() {
        return ''
      },
    },
  },
}
</script>
